import React from "react";
import AttendanceList from "../../../components/adm/attendance/attendanceFilterListNew";
import Layout from "../../../components/layouts/verticalLayout";
import { useLocation, useParams } from "react-router-dom";

const AttendanceListNewPage = () => {
  let { uuid } = useParams();
  const location = useLocation();
  const data = location.state;
  return <Layout body={<AttendanceList uuid={uuid} session={data} />} />;
};

AttendanceListNewPage.propTypes = {};

export default AttendanceListNewPage;
